import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { login } from "../../services/auth.services";
import { Link } from "react-router-dom";
import {
    forgetRememberedEmail,
    getRememberedEmail,
    handleNavigation,
    handleServerValidations,
    REMEMBERED_EMAIL_KEYS,
    setLocalKey,
    setRememberedEmail,
} from "../../../../utils/commonfunction";
import { SWAL_SETTINGS, ROLE, REST_LOGIN_ERROR_TYPES, LOADER_TIMEOUT_TIME } from "../../../../utils/Constants";
import { useTranslation } from "react-i18next";
import CustomError from "../../../../utils/customError";
import { useValidationSchemas } from "../../validator/validation";
import logo from '../../../../assets/logos/new_logo_black_3.png';   
import { useSelector } from "react-redux";


const Login = () => {
    const { t } = useTranslation()
    const { loginValidationSchema } = useValidationSchemas();
    const [show, setShow] = useState(true);
    const navigate = useNavigate();
    const myGlobalData = useSelector((state) => state.globalData?.data);
    const [getGlobalData, setGlobalData] = useState({});
    const [loader, setLoader] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);

    useEffect(() => {
        if (myGlobalData) {
            const settingsData = JSON.parse(myGlobalData);
            setGlobalData(settingsData);
        }
    }, [myGlobalData]);

    /** Remember last logged-in user — email only >>>> */
    useEffect(() => {
        const rememberedEmail = getRememberedEmail(REMEMBERED_EMAIL_KEYS.RESTAURANT);
        if (rememberedEmail) {
            formik.setFieldValue("email", rememberedEmail);
            setRememberMe(true);
        }
    }, []);
    /** Remember last logged-in user — email only <<<< */

    const handleshow = () => {
        setShow(!show);
    };



    const handleRememberMe = (e) => {
        const checked = e.target.checked;
        setRememberMe(checked);
        if (!checked) {
            forgetRememberedEmail(REMEMBERED_EMAIL_KEYS.RESTAURANT);
        }
    };

    const formik = useFormik({
        initialValues: {
            email: "",
            password: ""
        },
        validationSchema: loginValidationSchema,
        onSubmit: (values, { setSubmitting, resetForm }) => {
            const formData = new FormData();

            formData.append("email", values.email);
            formData.append("password", values.password)
            // WRDS-1150: drives the session length the backend signs, not just the prefill
            formData.append("remember_me", rememberMe)
            setLoader(true);

            login(formData)
                .then((response) => {
                    if (response.success) {
                        setTimeout(() => {
                            setLoader(false);
                          }, LOADER_TIMEOUT_TIME);
                        setRememberedEmail(
                            REMEMBERED_EMAIL_KEYS.RESTAURANT,
                            rememberMe ? values.email : ""
                        );
                        setLocalKey(ROLE.RESTAURANT, JSON.stringify(response.data));
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        handleNavigation({
                            successURL: "/restaurant/dashboard",
                            role: ROLE.RESTAURANT
                        });
                    } else {
                        setTimeout(() => {
                            setLoader(false);
                          }, LOADER_TIMEOUT_TIME);
                        let message = handleServerValidations(response);
                        /** Handling different types of server errors */
                        const supportUrlConditions = [REST_LOGIN_ERROR_TYPES.ACCOUNT_IS_BLOCKED, REST_LOGIN_ERROR_TYPES.SUBSCRIPTION_EXPIRED, REST_LOGIN_ERROR_TYPES.ACCOUNT_NOT_ENROLLED, REST_LOGIN_ERROR_TYPES.PASSWORD_NOT_SET_YET];
                        if (supportUrlConditions.indexOf(response.error_type) !== -1) {
                            message += `<a class="d-block mt-2 no-decoration link-text" href="/support/${response.error_type}">${t('btn_text_contact_us')}</a>`;
                        }
                        Swal.fire({
                            icon: "error",
                            html: message,
                            ...SWAL_SETTINGS
                        });
                    }
                })
                .catch((error) => {
                    setTimeout(() => {
                        setLoader(false);
                      }, LOADER_TIMEOUT_TIME);
                    console.log("error===>", error)
                })
        }
    });



    return (
        <div className="login-wrap">
            <div className="login-wrap-in">
                <div className="login-logo">

                    <img src={logo} alt="" />

                </div>
                <div className="login-form-wrap">
                    <div className="login-form-header">
                        <h4>{t('login_text')}</h4>
                        <p>{t('login_para_text')}</p>
                    </div>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="login-form">
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">{t('label_email_address')}<span>*</span></label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    name="email"
                                    placeholder={t('placeholder_email_address')}
                                    value={formik?.values?.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    autoComplete="username"
                                />
                                <span className="text-danger d-flex text-left">
                                    <CustomError name="email" form={formik} />
                                </span>

                            </div>
                            <div className="mb-3">
                                <label htmlFor="password" className="form-label">{t('label_password')}<span>*</span></label>
                                <div className="input-group">
                                    <input
                                        type={!show ? "text" : "password"}
                                        className="form-control border-end-0"
                                        id="password"
                                        placeholder={t('placeholder_password')}
                                        value={formik?.values?.password}
                                        name="password"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        autoComplete="current-password"
                                    />
                                    <span
                                        className="input-group-text cp restaurant-password-toggle"
                                        onClick={handleshow}
                                    >
                                        {!show === true ? (
                                            <i className="ti ti-eye"></i>
                                        ) : (
                                            <i className="ti ti-eye-off"></i>
                                        )}
                                    </span>
                                </div>

                                <span className="text-danger d-flex text-left">
                                    <CustomError name="password" form={formik} />
                                </span>

                            </div>
                            <div className="login-action-check d-flex justify-content-between align-items-center">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="rest-remember-me"
                                        value={"true"}
                                        checked={rememberMe}
                                        onChange={handleRememberMe}

                                    />
                                    <label className="form-check-label" htmlFor="rest-remember-me">
                                        {t("remember_me")}
                                    </label>

                                </div>
                                {/* <a href="#" className="link-text">Forgot password?</a> */}
                                <Link className="link-text" to="/restaurant/forget-password">
                                    {t("forgot_password")}?
                                </Link>

                            </div>
                            <button className="btn btn-primary w-100 mt-4 justify-content-center" disabled={loader}>
                            {loader === true ? (
                                    <div
                                      className="spinner-border mt-2 text-white"
                                      role="status"
                                      style={{
                                        height: "15px",
                                        width: "15px",
                                        marginRight: "15px",
                                      }}
                                    >
                                      <span className="sr-only ">
                                        {t("loading")}
                                      </span>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                
                                
                                
                                {t('link_login')}</button>
                          {getGlobalData.signup_option&& 
                           <div className="login-cta-bottom text-center mt-3">

                                <p>{t("dont_have_account_text")}
                                    <Link className="link-text ms-1" to="/restaurant/register">
                                        {t('label_register')}
                                    </Link>
                                </p>
                            </div>}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Login